import { IdiomaService } from './../../../providers/idioma/idioma.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../../providers/entity-manager-provider/entity-manager-provider';
import { Message } from 'primeng/primeng';
import { Noticia, NoticiaIdiomaFormulario } from '../../../domain/Noticia';

import { ActivatedRoute, Router } from '@angular/router';
import * as allSettled from 'promise-all-settled';
import { FileUpload } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/api';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { Idioma } from '../../../domain/Idioma';
import { TranslateService } from 'ng2-translate';
import { IdiomaCalendario } from '../../../domain/IdiomaCalendatio';
import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';
import { Constantes } from '../../../domain/constantes';
import { AppComponent } from '../../../app.component';
import { environment } from '../../../../environments/environment';


@Component({
	templateUrl: './nueva.noticia.component.html',
    providers: [ConfirmationService]
})

export class NuevaNoticiaComponent implements OnInit, OnDestroy {

	spinner: HTMLElement;
	msgs: Message[] = [];
	msgFoto: Message[] = [];
	noticiaSeleccionada: Noticia = new Noticia();
	idNoticia: string = null;
	edicion: boolean;
	selectorImagen: FileUpload;
	imagenSeleccionada: any;
	idiomaCalendario: IdiomaCalendario;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;

	public isValid = true;
	public tituloError = false;
	public fAltaError = false;
	public fBajaError = false;
	public imagenError = false;

		/* IMAGE CROPPER*/
		data: any;
		cropperSettings: CropperSettings;
		imageCropperVisible = false;

		@ViewChild('cropper', undefined)
		cropper: ImageCropperComponent;

	constructor(
		private appComponent: AppComponent,
		private router: Router,
		private route: ActivatedRoute,
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		public sws: ServiciosWebServiceProvider,
		private confirmationService: ConfirmationService,
		private breadcrumbService: BreadcrumbService,
		private idiomaService: IdiomaService,
		private translate: TranslateService
	) {
		this.cropperSettings = new CropperSettings();
		this.cropperSettings.width = 450;
		this.cropperSettings.height = 100;
		this.cropperSettings.croppedWidth = 450;
		this.cropperSettings.croppedHeight = 100;
		this.cropperSettings.canvasWidth = 450;
		this.cropperSettings.canvasHeight = 300;
		this.cropperSettings.noFileInput = true;
		this.cropperSettings.fileType = "image/webp";
		this.cropperSettings.minWithRelativeToResolution = true;

		this.data = {};

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Noticias.noticias'), routerLink: ['/noticias'] },
			{ label: this.translate.instant('Noticias.nuevanoticia') }
		]);

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');


		this.route.params
		.subscribe(params => {
			this.idNoticia = params['id'];
		});

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';
	}

	ngOnInit(){
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		console.log('*** NoticiasNuevaComponent ngOnInit ***');
		const that = this;
		if (this.idNoticia !== null && this.idNoticia !== '' && this.idNoticia !== undefined) {
			console.log('*** idNoticia NOT NULL ***');
			let includes = 'FOTOS, ';
			includes = includes + 'IDIOMAS';

			this.edicion = true;
			this.entityManager.getIDIOMA()
			.then(function (idiomasENTIDAD: any) {

				that.idiomas = [];
				idiomasENTIDAD.forEach(idioma => {
					if(idioma.Visible === true){
					that.idiomas.push(new Idioma(idioma));
					}
				});

				that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
				that.idiomaSeleccionado = that.idiomaDefecto;

				return that.entityManager.getNoticiaById(that.idNoticia, includes);
			})
			.then(function(noticias: any){

				const noticia = noticias[0];

				that.noticiaSeleccionada.Idiomas = that.idiomaService.getMapNoticiaIdiomas(noticia.IDIOMAS);

				that.noticiaSeleccionada.Titulo = noticia.Titulo;
				that.noticiaSeleccionada.TextoContenido = noticia.TextoContenido;
				that.noticiaSeleccionada.FechaAlta = noticia.FechaAlta;
				that.noticiaSeleccionada.FechaBaja = noticia.FechaBaja;
				that.noticiaSeleccionada.Imagen = that.authService.getFotoPorDefecto();
				that.noticiaSeleccionada.ENTIDAD = noticia;

				// FOTOS
				noticia.Imagen = that.authService.getFotoPorDefecto();
				const ultima = noticia.ENTIDAD.FOTOS.length - 1;
				if (ultima >= 0) {
					if (noticia.ENTIDAD.FOTOS[ultima].UrlFotoExt) {
						noticia.Imagen = noticia.ENTIDAD.FOTOS[ultima].UrlFotoExt;
					}
					else{
						noticia.Imagen =  environment.urlBaseFotos + noticia.ENTIDAD.FOTOS[ultima].IdFotoExt;
					}
				}
				else {
					noticia.Imagen = that.authService.getFotoPorDefecto();
				}

				that.spinner.style.display = 'none';
			});
		}
		else {
			console.log('*** idNoticia NULL ***');

			this.entityManager.getIDIOMA()
			.then(function (idiomasENTIDAD: any) {

				that.idiomas = [];
				idiomasENTIDAD.forEach(idioma => {
					if(idioma.Visible === true){
					that.idiomas.push(new Idioma(idioma));
					}
				});

				that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
				that.idiomaSeleccionado = that.idiomaDefecto;

				that.noticiaSeleccionada.Idiomas = that.idiomaService.newMapNoticiaIdiomas(that.idiomas);

				// Ocultamos Spinner
				that.spinner.style.display = 'none';
				that.edicion = false;

			});

		}

	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	/* FileUpload */
	onFileSelect($event, fileUploadComponent) {
		this.msgFoto = [];
		this.imagenSeleccionada = $event.files[0];
	}

	onRemoveSelect($event?, fileUploadComponent?){
		this.imagenSeleccionada = undefined;
	}

	eliminarUploadedFiles() {
		this.onRemoveSelect();
	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	/* Validar */
	inputChanged(value) {

		console.log('Implementar: Comprobar todas las noticias del mapNoticiaIdioma');
		const p1Error = this.noticiaSeleccionada.Titulo === '' || this.noticiaSeleccionada.Titulo === undefined;
		const p2Error = this.noticiaSeleccionada.FechaAlta === '' || this.noticiaSeleccionada.FechaAlta === undefined || this.noticiaSeleccionada.FechaAlta === null;
		const p3Error = false; // this.noticiaSeleccionada.FechaBaja === ''  || this.noticiaSeleccionada.FechaBaja === undefined  || this.noticiaSeleccionada.FechaBaja === null;
		const p4Error = this.noticiaSeleccionada.Imagen === undefined && this.imagenSeleccionada === undefined;

		// Validacion al guardar
		if (value === 'obligatorio'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}

			if (p2Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}

			if (p3Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}

			if (p4Error) {
				this.imagenError = true;
			}
			else {
				this.imagenError = false;
			}
		}
		// validacion al editar titulo
		else if (value === 'titulo'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}
		}
		// validacion al editar fecha_alta
		else if (value === 'fecha_alta'){
			if (p2Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}
		}
		// validacion al editar fecha_baja
		else if (value === 'fecha_baja'){
			if (p3Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
		}

		//  Cojemos la traduccion del espacio al idioma seleccionado
		const noticiaIdioma = this.noticiaSeleccionada.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		noticiaIdioma.Titulo = this.noticiaSeleccionada.Titulo;
		noticiaIdioma.TextoContenido = this.noticiaSeleccionada.TextoContenido;
		this.noticiaSeleccionada.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, noticiaIdioma);
	}

	public esEdicion(): boolean {
		return this.edicion;
	}

	public validar(): boolean {
		this.inputChanged('obligatorio');
		const p1 = this.tituloError;
		const p2 = this.fAltaError;
		const p3 = this.fBajaError;
		const p4 = this.imagenError;

		if (p1 || p2 || p3 || p4) {
			this.isValid = false;
			if (p4) {
				if (this.imagenError) {
					this.msgFoto.push({severity: 'error', summary: this.translate.instant('Noticias.imagenobligatoria'), detail: this.translate.instant('Noticias.debeelegirimagen')});
				}
			}
		}
		else {
			this.isValid = true;
		}

		return this.isValid;
	}

	cancelar(){
		this.confirmationService.confirm({
            message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_CANCELAR'),
            accept: () => {
				this.router.navigate(['/noticias']);
			},
			reject: () => {
				console.log('Cancelado el Cancelado de Noticia.');
			}
        });
	}

	public guardar(): any {


		this.confirmationService.confirm({
            message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR'),
            accept: () => {
				if (this.validar()) {
					if (!this.esEdicion()) {
						this.guardarNuevo();
					}
					else {
						this.guardarEdicion();
					}
				} else {
					this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
				}
			},
			reject: () => {
				console.log('Cancelado el Guardado de Contenido.');
			}
        });
	}

	public guardarNuevo() {
		const that = this;
		const idEspacio = this.authService.getIdEspacio();
		return this.entityManager.newNOTICIA()
		.then(function (oNoticia) {

			oNoticia.IDIOMAS.forEach(NOTICIA_IDIOMA => {
				const aux = that.noticiaSeleccionada.Idiomas.get(NOTICIA_IDIOMA.IDIOMA.Codigo);
				NOTICIA_IDIOMA.Nombre = aux.Titulo;
				NOTICIA_IDIOMA.Descripcion = aux.TextoContenido;
			});

			const espacioIdioma = that.noticiaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.noticiaSeleccionada.Titulo = espacioIdioma.Titulo ? espacioIdioma.Titulo : '';
			that.noticiaSeleccionada.TextoContenido = espacioIdioma.TextoContenido ? espacioIdioma.TextoContenido : '';

			oNoticia.IdEspacio = that.authService.getIdEspacio();
			oNoticia.Titulo = that.noticiaSeleccionada.Titulo;
			oNoticia.TextoContenido = that.noticiaSeleccionada.TextoContenido;
			oNoticia.FechaAlta = that.noticiaSeleccionada.FechaAlta;
			oNoticia.FechaBaja = that.noticiaSeleccionada.FechaBaja;

			that.noticiaSeleccionada.ENTIDAD = oNoticia;
			return that.entityManager.saveChanges();
		})
		.then(function (){
			return that.subirFotos();
		})
		.then(function () {
			that.appComponent.showSuccess('OK');
			that.router.navigate(['/noticias']);
			return 'OK';
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	public guardarEdicion() {

		const that = this;

		this.guardarMultiIdioma()
		.then(function (){
			const espacioIdioma = that.noticiaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.noticiaSeleccionada.Titulo = espacioIdioma.Titulo ? espacioIdioma.Titulo : '';
			that.noticiaSeleccionada.TextoContenido = espacioIdioma.TextoContenido ? espacioIdioma.TextoContenido : '';

			this.noticiaSeleccionada.ENTIDAD.Titulo = that.noticiaSeleccionada.Titulo;
			this.noticiaSeleccionada.ENTIDAD.TextoContenido = that.noticiaSeleccionada.TextoContenido;
			this.noticiaSeleccionada.ENTIDAD.FechaAlta = that.noticiaSeleccionada.FechaAlta;
			this.noticiaSeleccionada.ENTIDAD.FechaBaja = that.noticiaSeleccionada.FechaBaja;

			return that.entityManager.saveChanges();
		})
		.then(function (){
			return that.subirFotos();
		})
		.then(function () {
			that.appComponent.showSuccess('OK');
			that.router.navigate(['/noticias']);
			return 'OK';
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManager.deleteEntityArray(this.noticiaSeleccionada.ENTIDAD.IDIOMAS);

		return this.entityManager.newNOTICIA_IDIOMA(this.noticiaSeleccionada)
		.then(function(NOTICIA_IDIOMAs){

			NOTICIA_IDIOMAs.forEach(NOTICIA_IDIOMA => {
				const aux = that.noticiaSeleccionada.Idiomas.get(NOTICIA_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					NOTICIA_IDIOMA.Nombre = aux.Titulo;
					NOTICIA_IDIOMA.Descripcion = aux.TextoContenido;
				}

			});
		});
	}

	public subirFotos(){
		// PREPARAMOS LA SUBIDA DE LAS FOTOS
		const promises: any[] = [];
		const that = this;

		if (that.imagenSeleccionada !== undefined) {
			/*
			this.noticiaSeleccionada.ENTIDAD.FOTOS.forEach(foto => {
				this.entityManager.deleteEntity(foto);
			});

			promises.push(that.enviarFoto('IdNoticia', that.noticiaSeleccionada.ENTIDAD.Id, that.imagenSeleccionada));
			*/

			let idFoto = null;
			if (that.noticiaSeleccionada.ENTIDAD && that.noticiaSeleccionada.ENTIDAD.FOTOS) {
				const ultima = that.noticiaSeleccionada.ENTIDAD.FOTOS.length - 1;
				const fotoUpdate = that.noticiaSeleccionada.ENTIDAD.FOTOS[ultima];
				idFoto = fotoUpdate ? fotoUpdate.Id : null;
			}
			promises.push(that.enviarFoto('IdNoticia', that.noticiaSeleccionada.ENTIDAD.Id, that.imagenSeleccionada, idFoto));
		}

		return allSettled(promises);
	}

	enviarFoto(entidad, idEntidad, imagen, idFoto = null) {
		const token = this.authService.getToken();
		if (imagen !== undefined) {
			return this.sws.wsSubidaFoto(token, entidad, idEntidad, imagen, imagen.name, idFoto).toPromise();
		}
	}

	public eliminar() {
		const that = this;
		this.eliminarSeleccionado()
		.then(function () {
			that.appComponent.showSuccess('OK');
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	public eliminarSeleccionado() {
		const that = this;
		if (this.noticiaSeleccionada !== undefined) {
			this.entityManager.deleteEntity(this.noticiaSeleccionada);
			return this.entityManager.saveChanges();
		}
	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}

	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let noticiaIdioma = this.noticiaSeleccionada.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!noticiaIdioma) {

			noticiaIdioma = new NoticiaIdiomaFormulario();

			this.noticiaSeleccionada.Idiomas.set(idioma.value, noticiaIdioma);

		}

		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.noticiaSeleccionada.Titulo = noticiaIdioma.Titulo;
		this.noticiaSeleccionada.TextoContenido = noticiaIdioma.TextoContenido;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}

	/* Image Cropper */
	fileChangeListener($event) {
		this.imageCropperVisible = true;
		const image: any = new Image();
		const file: File = $event.target.files[0];
		const nombre = file.name;
		const tipo = file.type;
		const myReader: FileReader = new FileReader();
		const that = this;
		myReader.onloadend = function (loadEvent: any) {
			image.src = loadEvent.target.result;
			that.cropper.setImage(image);
			that.sws.base64ToFile(image.src, nombre, tipo)
			.then(function(fotoFile){
				that.imagenSeleccionada = fotoFile;
			});
		};
		myReader.readAsDataURL(file);
	}

	asignarFotoCropp($event){
		const that = this;
		this.sws.base64ToFile(this.data.image, that.imagenSeleccionada.name)
		.then(function(fotoFile){
			that.imagenSeleccionada = fotoFile;
			that.imageCropperVisible = false;
		});
	}
}





// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Noticias/nuevo/nueva.noticia.component.ts